import { useNavigate } from 'react-router-dom';
import AlbumImage from '../../images/album.image';
import Card from '../card';

type Props = {
  title: string;
  imageSrc: string;
  path: string;
};

export default function CategoryCard({ imageSrc, path, title }: Props) {
  const navigate = useNavigate();
  return (
    <Card
      onClick={() => navigate(path)}
      className="flex flex-col gap-2 cursor-pointer"
    >
      <Card.Body>
        <AlbumImage
          src={imageSrc}
          alt={title}
          className="release-category-cover"
        />
      </Card.Body>
      <Card.Footer>
        <div className="font-text capitalize text-primary font-medium">
          {title}
        </div>
      </Card.Footer>
    </Card>
  );
}
